import {
  StringValuesBuilderImpl3ey9etj3bwnqf as StringValuesBuilderImpl,
  StringValuesImpl2l95y9du7b61t as StringValuesImpl,
  StringValuesjqid5a6cuday as StringValues,
  get3oezx9z3zutmm as get,
  forEachghjt92rkrpzo as forEach,
  StringValuesSingleImpl1uh7q2c2zm7va as StringValuesSingleImpl,
} from '../../../../ktor-ktor-utils/io/ktor/util/StringValues.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpHeaders_getInstance2ik2fiom4sc0n as HttpHeaders_getInstance } from './HttpHeaders.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HeadersBuilderClass;
function HeadersBuilder() {
  if (HeadersBuilderClass === VOID) {
    class $ extends StringValuesBuilderImpl() {
      constructor(size) {
        size = size === VOID ? 8 : size;
        super(true, size);
      }
      l38() {
        return new (HeadersImpl())(this.p4t_1);
      }
      q4t(name) {
        super.q4t(name);
        HttpHeaders_getInstance().x54(name);
      }
      v4t(value) {
        super.v4t(value);
        HttpHeaders_getInstance().y54(value);
      }
    }
    initMetadataForClass($, 'HeadersBuilder', HeadersBuilder);
    HeadersBuilderClass = $;
  }
  return HeadersBuilderClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.z54_1 = EmptyHeaders_instance;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function headersOf(name, value) {
  return new (HeadersSingleImpl())(name, listOf(value));
}
var HeadersImplClass;
function HeadersImpl() {
  if (HeadersImplClass === VOID) {
    class $ extends StringValuesImpl() {
      constructor(values) {
        values = values === VOID ? emptyMap() : values;
        super(true, values);
      }
      toString() {
        return 'Headers ' + toString(this.m4t());
      }
    }
    initMetadataForClass($, 'HeadersImpl', HeadersImpl, VOID, [StringValues()]);
    HeadersImplClass = $;
  }
  return HeadersImplClass;
}
var EmptyHeadersClass;
function EmptyHeaders() {
  if (EmptyHeadersClass === VOID) {
    class $ {
      r4t() {
        return true;
      }
      s4t(name) {
        return null;
      }
      t4t() {
        return emptySet();
      }
      m4t() {
        return emptySet();
      }
      n1() {
        return true;
      }
      toString() {
        return 'Headers ' + toString(this.m4t());
      }
    }
    protoOf($).d2p = get;
    protoOf($).y4t = forEach;
    initMetadataForObject($, 'EmptyHeaders', VOID, VOID, [StringValues()]);
    EmptyHeadersClass = $;
  }
  return EmptyHeadersClass;
}
var EmptyHeaders_instance;
function EmptyHeaders_getInstance() {
  return EmptyHeaders_instance;
}
var HeadersSingleImplClass;
function HeadersSingleImpl() {
  if (HeadersSingleImplClass === VOID) {
    class $ extends StringValuesSingleImpl() {
      constructor(name, values) {
        super(true, name, values);
      }
      toString() {
        return 'Headers ' + toString(this.m4t());
      }
    }
    initMetadataForClass($, 'HeadersSingleImpl', VOID, VOID, [StringValues()]);
    HeadersSingleImplClass = $;
  }
  return HeadersSingleImplClass;
}
//region block: init
EmptyHeaders_instance = new (EmptyHeaders())();
//endregion
//region block: exports
export {
  Companion_getInstance as Companion_getInstance1fjhglsqufscv,
  HeadersBuilder as HeadersBuilder3h7sn3kkvu98m,
  headersOf as headersOf2tgdoojg8tifn,
};
//endregion

//# sourceMappingURL=Headers.mjs.map
